export default {
  pageTitle: 'Fabrikasi Vessel',
  metaDescription: 'TEF memfabrikasi pressure vessel, reaktor, storage tank, dan autoclave berbahan stainless steel, titanium, duplex, dan material khusus lainnya untuk kebutuhan proses industri.',
  sidebar: {
    title: 'Daftar Fabrikasi',
    vessel: 'Fabrikasi Vessel',
    heatExchanger: 'Fabrikasi Heat Exchanger',
    piping: 'Fabrikasi Piping',
    tower: 'Fabrikasi Tower',
    muffle: 'Fabrikasi Muffle',
    radiantTube: 'Fabrikasi Radiant Tube',
    otherEquipment: 'Fabrikasi Peralatan Lainnya',
  },
  fabricationOf: 'Fabrikasi',
  productName: 'Vessel',
  description: 'Berikut adalah katalog pengalaman kami dalam fabrikasi Vessel dengan berbagai jenis material, tipe, dan spesifikasi.',
};
